import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.scss';

const NotFound = () => {
  return (
    <section className="not-found-section">
      <div className="not-found-left-bg">
        <img src="/images/not-found-left-bg-d.png" alt="404 Left Background" />
      </div>
      <div className="not-found-right-bg">
        <img src="/images/not-found-right-bg-d.png" alt="404 Right Background" />
      </div>
      
      <div className="container">
        <div className="not-found-content">
          <h1 className="not-found-title">
            <span className="four-digit">4</span>
            <span className="ball-icon">
              <img src="/icons/404-ball.svg" alt="404 Ball" />
            </span>
            <span className="four-digit">4</span>
          </h1>
          <p className="not-found-text">
            Üzgünüz, aradığınız sayfa bulunamadı. İlgili içeriğe ulaşmak için menüyü kullanabilir ya da ana sayfamıza dönebilirsiniz.
          </p>
          <Link to="/" className="back-home-btn">Ana Sayfaya Dön</Link>
        </div>
      </div>
    </section>
  );
};

export default NotFound; 